<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="所属贝展">{{info.exh_title}}</a-form-item>
      <a-form-item label="活动标题">{{info.name}}</a-form-item>
      <a-form-item label="活动Logo">
        <img v-if="info.logo" height="60px" :src="this.API + info.logo" alt="">
      </a-form-item>
      <a-form-item label="活动海报">
        <img v-if="info.thumb" height="100px" :src="this.API + info.thumb" alt="">
      </a-form-item>
      </a-form-item>
      <a-form-item label="活动简介">{{info.desc}}</a-form-item>
      <a-form-item label="活动场地">{{info.place}}</a-form-item>
      <a-form-item label="详细地址">{{info.addr}}</a-form-item>
      <a-form-item label="经纬度">{{info.lat}},{{info.lng}}</a-form-item>
      <a-form-item label="主办方">{{info.zhuban}}</a-form-item>
      <a-form-item label="协办方">{{info.xieban}}</a-form-item>
      <a-form-item label="报名费">{{info.fee}} 元</a-form-item>
      <a-form-item label="活动时间">{{info.start_at}} - {{info.end_at}}</a-form-item>
      <a-form-item label="报名时间">{{info.join_start}} - {{info.join_end}}</a-form-item>
      <a-form-item label="限制总人数">{{info.amount_limit}}</a-form-item>
      <a-form-item label="报名限制">{{info.join_limit}}</a-form-item>
      <a-form-item label="需要报名">{{info.need_join == 1 ? '是' : '否'}}</a-form-item>
      <a-form-item label="需要邀请">{{info.yaoqing == 1 ? '是' : '否'}}</a-form-item>
      <a-form-item label="需要审核">{{info.need_app == 1 ? '是' : '否'}}</a-form-item>
      <a-form-item label="优惠券">{{info.coupon_name}}</a-form-item>
      <a-form-item label="详细介绍">
        <div v-html="info.content"></div>
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="update">编辑</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec{
  margin: 15px;
}
img{
  max-width: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      info: {},
    };
  },
  async created () {
    const id = this.$route.query.id;
    const r = await this.$axios.get('/activity/getInfo?id=' + id);
    if(r.status == 1){
      this.info = r.info
    }
  },
  methods: {
    update () {
      this.$router.push(`/activity/update?id=${this.info.id}`)
    }
  },
};
</script>